export default __webpack_public_path__ + "static/media/img-guide-03@3x.42cc08b1.png";